var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.format != 'qr')?_c('svg',{ref:"barcode"}):(_vm.qrUrl)?_c('img',{attrs:{"src":_vm.qrUrl}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }